import _, { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { findDOMNode } from "react-dom";

import { asDragSource } from "../../components/dragAndDrop/DraggableComponent";
import ListItemView from "../../components/listView/ListItemView";
import { MODAL_MASTER_LIST_VIEW } from "../../constants/identifiers";
import { PropTypeShapes } from "../../types";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";

const MODAL_MASTER_LIST_ITEM_ID = "MODAL_MASTER_LIST_ITEM_ID";

const clickWasGutter = e => hasAncestorOfClass(e.target, "listItemGutter");

const dragCallbacks = {
  beginDrag: _props => {
    // TODO: Do we want to set isDragging or similar...?
  },

  canDrag: (props, _dragSource, e) => {
    //#!if iOS === true
// return props.canDrag && clickWasGutter(e);
    //#!endif

    // eslint-disable-next-line no-unreachable
    return props.canDrag;
  },

  getDragSourceParams: props => {
    return {
      itemId: `${props.viewId}-${props.index}`,
      index: props.index,
      itemType: MODAL_MASTER_LIST_ITEM_ID,
      sourceView: props.viewId,
      sourceViewType: MODAL_MASTER_LIST_VIEW
    };
  },

  getPreviewElement: (props, dragSource) => renderItemPreview(props, dragSource)
};

const renderItemPreview = (itemProps, dragSource) => {
  const sourceRect = dragSource && dragSource.node ? dragSource.node.getBoundingClientRect() : null;
  const cloneProps = _.clone(itemProps);
  cloneProps.isSelected = false;
  cloneProps.slideUp = false;
  cloneProps.slideDown = false;
  cloneProps.onClick = null;
  cloneProps.onSuperClick = null;
  return renderItem(cloneProps, sourceRect.width);
};

const renderItem = (useProps, fixedWidth) => {
  let style = {
    opacity: useProps.isDragging ? 0 : 1
  };

  if (!isNil(useProps.width)) {
    style.width = `${useProps.width}px`;
  } else if (!isNil(fixedWidth)) {
    style.width = `${fixedWidth}px`;
  }

  const listItemView = <ListItemView useDragHandle={useProps.useDragHandle} {...useProps} />;

  return (
    <div
      ref={useProps.forwardedRef}
      className={`modalMasterListItem ${useProps.slideUp ? "slideUp" : ""} ${useProps.slideDown ? "slideDown" : ""} ${
        useProps.className ? useProps.className : ""
      }`}
      style={style}
    >
      {listItemView}
    </div>
  );
};

class ModalMasterListItem extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      disableDrag: false
    };
  }

  componentDidMount() {
    this._domNode = findDOMNode(this);
  }

  render() {
    return renderItem(this.props);
  }
}

ModalMasterListItem.propTypes = {
  index: PropTypes.number,
  text: PropTypes.string,
  leftElements: PropTypeShapes.elementOrArray,
  rightElements: PropTypeShapes.elementOrArray,
  viewId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  width: PropTypes.number,
  clickContext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  useDragHandle: PropTypes.bool,
  className: PropTypes.string,

  // Sliding out of way
  canDrag: PropTypes.bool,
  slideUp: PropTypes.bool,
  slideDown: PropTypes.bool,

  // From asDragSource
  isDragging: PropTypes.bool,
  dragIsFromSameSource: PropTypes.bool
};

export default asDragSource(ModalMasterListItem, MODAL_MASTER_LIST_VIEW, dragCallbacks);
